export const SPORTS_REQUEST = 'sportsRequest';
export const SPORTS_FAILURE = 'sportsFailure';
export const SPORTS_SUCCESS = 'sportsSuccess';
